import { useState } from 'react';
import Question from '@/components/Faq/Question';

export interface IFaqItem {
    title: string;
    description: string;
    /** Optional origin tag (terms vs faq); kept for callers that still set it. */
    kind?: 'terms' | 'faq';
}

// Back-compat alias — older imports referenced IQuestion.
export type IQuestion = IFaqItem;

interface Props {
    items: IFaqItem[];
}

const QuestionList = ({ items }: Props) => {
    const [opened, setOpened] = useState<number[]>([]);

    function toggle(i: number) {
        setOpened((prev) => (prev.includes(i) ? prev.filter((x) => x !== i) : [...prev, i]));
    }

    if (!items || items.length === 0) {
        return (
            <div className="surface px-5 py-8 text-center text-text_3 text-sm font-chat-msg">
                Nothing here yet.
            </div>
        );
    }

    return (
        <div className="flex flex-col gap-2.5 min-w-0">
            {items.map((q, i) => (
                <Question
                    key={`${q.kind ?? 'faq'}-${i}-${q.title}`}
                    index={i + 1}
                    question={q}
                    isOpen={opened.includes(i)}
                    onToggle={() => toggle(i)}
                />
            ))}
        </div>
    );
};

export default QuestionList;
